import React, { PureComponent, Children } from 'react'
import {
  bool, string, func, shape, node,
} from 'prop-types'
import Button from '@active/react-ui/Button'
import FormField from '@active/react-ui/FormField'
import PasswordInput from '@active/react-ui/PasswordInput'
import Checkbox from '@active/react-ui/Checkbox'
import FormGroup from '@active/react-ui/FormGroup'
import FormLabel from '@active/react-ui/FormLabel'
import FormStaticField from '@active/react-ui/FormStaticField'
import Link from '@active/react-ui/Link'
import Identity from '@active/react-utils/components/Identity'
import { withI18n } from '@active/react-utils/i18n'
import EmailInput from '@active/react-ui/EmailInput'
import Form from '../../common/InjectedForm'
import { ErrorContent } from '../../common/Layout'
import { isTrue } from '../../../shared/utils/commonUtils'

import './SigninForm.scss'
import I18nMessage from '../../common/I18nMessage'

class SigninForm extends PureComponent {
  static propTypes = {
    i18n: func.isRequired,
    children: node,
    username: string,
    showError: bool,
    remember: bool,
    errorMsg: string,
    fields: shape({
      accountname: string,
      pawd: string,
    }),
    existingAccount: bool.isRequired,
    onSubmit: func.isRequired,
    onForgotPawd: func.isRequired,
    onRememberCheckboxChange: func.isRequired,
    onUserNameBlur: func.isRequired,
    disableForgotPawd: bool,

    hideStaySignin: bool,
    usernameReadonly: string,
  }

  static defaultProps = {
    children: undefined,
    username: '',
    errorMsg: '',
    showError: false,
    remember: false,
    fields: {},
    disableForgotPawd: false,
    hideStaySignin: false,
    usernameReadonly: '',
  }

  constructor(props) {
    super(props)
    const { fields, username, remember } = this.props
    const initialValues = {
      ...fields,
      accountname: username,
      remember,
    }
    this.state = {
      initialValues,
      currentUsername: initialValues.accountname,
    }
  }

  validateMax = value => {
    const { i18n } = this.props
    if (value && value.length > 50) {
      return i18n('react-ui.validation.max', { max: 50 })
    }
    return undefined
  }

  handleUsernameChange = value => {
    this.setState({
      currentUsername: value,
    })
  }

  render() {
    const {
      showError, errorMsg, existingAccount, disableForgotPawd,
      onSubmit, onForgotPawd, onRememberCheckboxChange, onUserNameBlur, hideStaySignin,
      usernameReadonly, children,
    } = this.props
    const { initialValues, currentUsername } = this.state
    return (
      <Identity>
        {showError && <ErrorContent errorMsg={errorMsg} autoScrollOnShow scrollDedupeKey="signin-form-error" />}
        <div className="passport__form passport__signin__form">
          <Form
            className="clearfix"
            initialValues={initialValues}
            onSubmit={onSubmit}
          >
            {existingAccount ? (
              <div className="passport__signin__account-exist">
                <div className="passport__signin__account-exist-tip">
                  <I18nMessage id="passport.signin.notice.accountExsist" />
                </div>

                <FormGroup className="username-text" name="accountname" withoutLayout hideAsterisk>
                  <FormStaticField />
                </FormGroup>

                <FormGroup name="pawd" required withoutLayout hideAsterisk>
                  <FormLabel><I18nMessage id="passport.signin.label.password" /></FormLabel>
                  <FormField
                    requiredError="passport.error.validation.noPassword"
                    validate={this.validateMax}
                    autoComplete="new-password"
                    as={PasswordInput}
                  />
                </FormGroup>

              </div>
            ) : (
              <div className="passport__signin__account-not-exist">

                <FormGroup name="accountname" required withoutLayout hideAsterisk>
                  <FormLabel><I18nMessage id="passport.common.label.emailAddress" /></FormLabel>
                  {isTrue(usernameReadonly) && currentUsername
                    ? <FormStaticField className="username-text font-weight-600 passport__wordbreak" />
                    : (
                      <FormField
                        autoComplete="email"
                        onChange={this.handleUsernameChange}
                        onBlur={onUserNameBlur}
                        className="username-text font-weight-600 passport__wordbreak"
                        as={EmailInput}
                        requiredError="passport.error.validation.invalidEmail"
                        invalidError="passport.error.validation.invalidEmail"
                      />
                    )}
                </FormGroup>

                <FormGroup name="pawd" required withoutLayout hideAsterisk>
                  <FormLabel><I18nMessage id="passport.common.label.password" /></FormLabel>
                  <FormField
                    requiredError="passport.error.validation.noPassword"
                    validate={this.validateMax}
                    autoComplete="new-password"
                    as={PasswordInput}
                  />
                </FormGroup>

              </div>
            )}
            {!hideStaySignin && (
              <Checkbox className="passport__signin__form__stay-sigin" onChange={onRememberCheckboxChange} name="remember">
                <I18nMessage id="passport.signin.label.staySignedIn" />
              </Checkbox>
            )}
            {!disableForgotPawd && (
              <Link
                tabIndex={0}
                onClick={onForgotPawd}
                onKeyDown={e => {
                  if (e.key === 'Enter' || e.key === ' ') {
                    onForgotPawd()
                  }
                }}
                className="passport__signin__forgot-pawd"
              >
                <I18nMessage id="passport.signin.label.forgotPassword" />
              </Link>
            )}
            <Button submit type="super" className="passport__signin__submit-button">
              <I18nMessage id="passport.common.btn.signIn" />
            </Button>
          </Form>
          {children && Children.only(children)}
        </div>
      </Identity>
    )
  }
}

export default withI18n(SigninForm)
